// Zen custom logo — Line-art Lotus (terracotta) rising from Water currents (turquoise).
// Traditional lotus symbolism: pureté qui s'élève de l'eau.
// Palette: turquoise #3D8C95, terracotta #E07A5F.
export default function Logo({ size = 64, className = "" }) {
    return (
        <span
            data-testid="brand-logo"
            aria-label="Jérémy Tessier — Massothérapie"
            className={`relative inline-flex items-center justify-center ${className}`}
            style={{ width: size, height: size }}
        >
            {/* Soft ambient wash */}
            <span
                aria-hidden="true"
                className="absolute inset-0 rounded-full"
                style={{
                    background:
                        "radial-gradient(circle at 50% 50%, rgba(232,226,217,0.55) 0%, rgba(250,247,242,0.25) 55%, transparent 78%)",
                }}
            />
            <svg
                width={size}
                height={size}
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                className="relative"
            >
                {/* ————— LOTUS (terracotta, line-art) — LARGE, fills the composition ————— */}
                <path d="M 50 62 Q 40 40 50 12 Q 60 40 50 62 Z" stroke="#E07A5F" strokeWidth="2.6" strokeLinejoin="round" transform="rotate(-72 50 62)" />
                <path d="M 50 62 Q 40 40 50 12 Q 60 40 50 62 Z" stroke="#E07A5F" strokeWidth="2.6" strokeLinejoin="round" transform="rotate(72 50 62)" />
                <path d="M 50 62 Q 40 38 50 10 Q 60 38 50 62 Z" stroke="#E07A5F" strokeWidth="2.6" strokeLinejoin="round" transform="rotate(-42 50 62)" />
                <path d="M 50 62 Q 40 38 50 10 Q 60 38 50 62 Z" stroke="#E07A5F" strokeWidth="2.6" strokeLinejoin="round" transform="rotate(42 50 62)" />
                <path d="M 50 62 Q 40 36 50 8 Q 60 36 50 62 Z" stroke="#E07A5F" strokeWidth="2.6" strokeLinejoin="round" transform="rotate(-18 50 62)" />
                <path d="M 50 62 Q 40 36 50 8 Q 60 36 50 62 Z" stroke="#E07A5F" strokeWidth="2.6" strokeLinejoin="round" transform="rotate(18 50 62)" />
                <path d="M 50 62 Q 40 34 50 4 Q 60 34 50 62 Z" stroke="#E07A5F" strokeWidth="2.8" strokeLinejoin="round" />
                <circle cx="50" cy="30" r="1.8" fill="#E07A5F" />

                {/* ————— WATER CURRENTS (turquoise, line-art) — flowing beneath the lotus ————— */}
                {/* Top wave — closest to the lotus, most defined */}
                <path
                    d="M 6 72
                       C 16 66, 26 78, 36 72
                       S 56 66, 66 72
                       S 86 78, 94 72"
                    stroke="#3D8C95"
                    strokeWidth="3.2"
                    strokeLinecap="round"
                />
                {/* Middle wave — offset for organic flow */}
                <path
                    d="M 10 82
                       C 20 76, 30 88, 42 82
                       S 62 76, 72 82
                       S 88 88, 92 82"
                    stroke="#3D8C95"
                    strokeWidth="2.8"
                    strokeLinecap="round"
                    opacity="0.85"
                />
                {/* Bottom wave — softer, adds depth */}
                <path
                    d="M 14 92
                       C 24 88, 36 96, 48 92
                       S 68 88, 78 92
                       S 90 94, 92 92"
                    stroke="#3D8C95"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    opacity="0.6"
                />
                {/* Tiny ripple droplets — subtle detail */}
                <circle cx="22" cy="66" r="0.9" fill="#3D8C95" opacity="0.55" />
                <circle cx="78" cy="66" r="0.9" fill="#3D8C95" opacity="0.55" />
            </svg>
        </span>
    );
}
